export default "__VITE_ASSET__c918de94__"